import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { NumberFormat } from 'components/Elements'

import { Table } from '../Table'

export const CandidatesViewsBlock = ({ data = {} }) => {
  const { t } = useTranslation()

  const { per_employer, period, total } = data

  const items = [
    {
      label: t('per_employer'),
      Cell: () => <NumberFormat value={per_employer} />,
    },
    {
      label: t('amount'),
      Cell: () => <NumberFormat value={period} />,
    },
    {
      label: t('total_amount'),
      Cell: () => <NumberFormat value={total} />,
    },
  ]

  return (
    <>
      <h4 className="font-size-18">{t('candidates_views')}</h4>

      <Table items={items} />
    </>
  )
}

CandidatesViewsBlock.propTypes = {
  data: PropTypes.object,
}
